import { axiosInstance } from "../axiosInstance";

export const getAllTimeslots = async () => {
  const instance = await axiosInstance();
  return await instance.get("/timeslot");
};
